import store from "../store";

export default {
  install(Vue) {
    Vue.prototype.$alert = function (title, type, extraConfig = {}) {
      return this.$root.$emit("alert", { title, type, ...extraConfig });
    };

    Vue.prototype.$theme = function () {
      const theme = store.state.theme;

      return this.$vuetify.theme.themes[theme];
    };
  },
};
